module.exports = __webpack_public_path__ + "static/media/WhoWeHelp.9bcf44b3.jpg";